/**
 * Registreringsnummer i dashboard-widgetar.
 * Admin och Fleet Manager (samt global admin) öppnar fordonskortet.
 */

import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from '@/store/languageStore';
import { useAuthStore } from '@/store/authStore';
import VehicleCard from '@/components/vehicle/VehicleCard';
import { userMayOpenVehicleCard } from './canOpenVehicleCard';
import { registrationLabel } from './registrationLabel';

interface VehicleRegistrationLinkProps {
  registrationNumber: unknown;
  vehicleId?: number | null;
  className?: string;
}

const VehicleRegistrationLink: React.FC<VehicleRegistrationLinkProps> = ({
  registrationNumber,
  vehicleId,
  className,
}) => {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const [open, setOpen] = useState(false);
  const label = registrationLabel(registrationNumber);
  const canOpen = label.length > 0 && userMayOpenVehicleCard(user);

  if (!canOpen) {
    return <span className={className}>{label || '–'}</span>;
  }

  const card = open
    ? createPortal(
        <VehicleCard
          registrationNumber={label}
          vehicleId={vehicleId != null && vehicleId > 0 ? vehicleId : undefined}
          onClose={() => setOpen(false)}
        />,
        document.body,
      )
    : null;

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        className={`text-left underline decoration-dotted underline-offset-2 hover:text-primary hover:decoration-solid ${className ?? ''}`}
        title={t('widgets.openVehicleCard')}
      >
        {label}
      </button>
      {card}
    </>
  );
};

export default VehicleRegistrationLink;
